<template>
  <span :class="suspectedFraudClass" v-if="isShowSuspectedIcon(authorization.privileges, assist.dataType.PrivilegeCode.FRAUD_WARNING, assist.dataType.PrivilegeType.EXECUTABLE) && suspected">
    <template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text icon v-bind="attrs" depressed v-on="on" style="margin-top: 8px" @click="doHandler">
            <head-alert :primary-color="handler.color"></head-alert>
          </v-btn>
        </template>
        <span>{{ suspectedTitle }}</span>
      </v-tooltip>
    </template>
    <v-dialog v-model="suspectedDisplay" max-width="600px" persistent>
      <v-card max-width="600px">
        <v-toolbar color="primary" dark>
          <span class="headline">{{ title }} Anti-Fraud Warning</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="suspectedDisplay = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="m-t-20">
          <v-textarea
              outlined
              label="note"
              v-model="suspectedValue"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              text
              @click="submitNote(1)"
          >Yes</v-btn><v-btn
            text
            @click="submitNote(2)"
        >No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { DataType, Tool, Popup, Authentication } from '@/util/index'
import { OriginationBusinessApi } from '@/api/lms/origination-business'
import HeadAlert from '@/components/panda/pre-origination/detail/HeadAlert'

const tool = new Tool()
const popup = new Popup()

export default {
  name: 'suspected-fraud',
  components: {
    HeadAlert
  },
  props: {
    loan: Object,
    authorization: Object
  },
  data () {
    return {
      handler: {
        color: 'grey',
        handledFlag: 0
      },
      suspectedFraudClass: '',
      suspectedDisplay: false,
      suspectedValue: '',
      suspectedTitle: '',
      type: 1,
      flag: -1,
      suspected: false,
      title: '',
      assist: {
        dataType: DataType
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId: {
      handler: function () {
        if (this.$route.path.includes(DataType.RouterPath.LOS_PATH)) {
          this.suspectedFraudClass = 'suspected-fraud-style'
        }
        if (tool.isNotEmpty(this.loan.id)) {
          this.getHandledFlag(this.loan.id)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.$eventBus.$on('suspectedRisk', target => {
      if (tool.isNotEmpty(target) && tool.isNotEmpty(this.loan.id)) {
        this.getHandledFlag(this.loan.id)
      }
    })
  },
  methods: {
    doHandler () {
      if (this.$route.path.includes(DataType.RouterPath.LOS_PATH)) {
        if (this.flag === DataType.FraudFlag.SUSPECTED.value || this.flag === DataType.FraudFlag.RELEASED.value) {
          this.suspectedDisplay = true
        } else {
          this.suspectedDisplay = false
        }
      }
    },
    getHandledFlag (loanId) {
      const $this = this
      OriginationBusinessApi.getFraudFlag({ loanId }, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.suspected = true
          $this.flag = result.flag
          $this.type = result.type
          if (result.flag === DataType.FraudFlag.SUSPECTED.value) {
            $this.handler = {
              color: 'red'
            }
            $this.title = 'Releasing'
            $this.suspectedTitle = DataType.FraudFlag.SUSPECTED.text
          } else {
            if (result.flag === DataType.FraudFlag.MISMATCHED_IBV.value) {
              $this.suspectedTitle = DataType.FraudFlag.MISMATCHED_IBV.text
              $this.handler = {
                color: '#FF9700'
              }
              $this.suspectedTitle = DataType.FraudFlag.MISMATCHED_IBV.text
              $this.suspectedDisplay = false
            } else {
              $this.handler = {
                color: 'grey'
              }
              $this.title = 'Suspecting'
              $this.suspectedTitle = DataType.FraudFlag.RELEASED.text
            }
          }
        } else {
          $this.suspected = false
        }
      })
    },
    submitNote (flags) {
      let inputData = {}
      if (flags === 1) {
        inputData = {
          loanId: this.loanId,
          type: this.type,
          flag: -this.flag,
          note: this.suspectedValue
        }
      } else {
        inputData = {
          loanId: this.loanId,
          type: this.type,
          flag: this.flag,
          note: this.suspectedValue
        }
      }
      if (tool.isEmpty(this.suspectedValue)) {
        popup.popupForInfo('please add note')
      } else {
        const $this = this
        OriginationBusinessApi.FraudReleased(inputData, function (result) {
          if (tool.isNotEmpty(result)) {
            popup.popupForSuccess('Success')
            $this.suspectedValue = ''
            $this.suspectedDisplay = false
            $this.getHandledFlag($this.loanId)
          } else {
            popup.popupForError('failure')
          }
        })
      }
    },
    isShowSuspectedIcon (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    }
  }
}
</script>
<style lang="scss" scoped>
.suspected-fraud-style {
  border-top-right-radius: 6px;
  display: block;
  position: relative;
  float: right;
  color: white;
  opacity: 0.88;
  height: 10px;
  margin-right: 10px;
  bottom: 7px
}
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 48px; }
</style>
